<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12Af71l/CoverDesign.jpg?1684514529387" alt="This image is the cover for the book Amy Lane's Greatest Hits - Dark Contemporary, Dreamspinner Press Bundles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amy Lane's Greatest Hits - Dark Contemporary, Dreamspinner Press Bundles
      </h1>
      <p class="bookDescription body article font2">
        <p>Love will survive, but it's a rough road. Don't miss these best-selling tear-jerker contemporary romances from Amy Lane.—<em>Keeping Promise Rock</em>: When Crick’s knack for volatile decisions lands him far away from home, Deacon is left, shell-shocked and alone, struggling to reforge his heart in a world where love with Crick is a promise, but by no means a certainty.—<em>Racing for the Sun</em>: When Sonny’s ghosts drive them down and run their plans off the road, Ace finds out exactly what he’s made of. Maybe Sonny was the one to promise Ace anything, but there is nothing under the sun Ace won’t do to keep Sonny safe from harm.—<em>Chase in Shadow</em>: Chase has one chance for true love and salvation. He may have met Tommy Halloran in the world of gay-for-pay—where the number of lovers doesn’t matter as long as the come-shot’s good—but if he wants the healing that Tommy’s love has to offer, he’ll need the courage to leave the shadows for the sunlight.—<em>Talker</em>: Brian is outwardly straight, but Talker is desperate for love, and when Talker’s behavior leads to some painful consequences, Brian is forced to come out of his closet—in dramatic fashion.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Lane
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f038b2b